// # THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { Builder, withChildren } from "@builder.io/react";

import { Accordion } from "../../slate/Accordion/Accordion";
import { BuilderConfig as AccordionConfig } from "../../slate/Accordion/Accordion.builder";
import { Button } from "../../slate/Button/Button";
import { BuilderConfig as ButtonConfig } from "../../slate/Button/Button.builder";
import { Arrow } from "../../slate/icons/foundation/Arrow";
import { BuilderConfig as ArrowConfig } from "../../slate/icons/foundation/Arrow.builder";
import { Check } from "../../slate/icons/foundation/Check";
import { BuilderConfig as CheckConfig } from "../../slate/icons/foundation/Check.builder";
import { Dollar } from "../../slate/icons/foundation/Dollar";
import { BuilderConfig as DollarConfig } from "../../slate/icons/foundation/Dollar.builder";
import { Euro } from "../../slate/icons/foundation/Euro";
import { BuilderConfig as EuroConfig } from "../../slate/icons/foundation/Euro.builder";
import { FoundationIcon } from "../../slate/icons/foundation/FoundationIcon";
import { BuilderConfig as FoundationIconConfig } from "../../slate/icons/foundation/FoundationIcon.builder";
import { Graph } from "../../slate/icons/foundation/Graph";
import { BuilderConfig as GraphConfig } from "../../slate/icons/foundation/Graph.builder";
import { PaymentPlan } from "../../slate/icons/foundation/PaymentPlan";
import { BuilderConfig as PaymentPlanConfig } from "../../slate/icons/foundation/PaymentPlan.builder";
import { Pound } from "../../slate/icons/foundation/Pound";
import { BuilderConfig as PoundConfig } from "../../slate/icons/foundation/Pound.builder";
import { ShareHeart } from "../../slate/icons/foundation/ShareHeart";
import { BuilderConfig as ShareHeartConfig } from "../../slate/icons/foundation/ShareHeart.builder";
import { Twinkle } from "../../slate/icons/foundation/Twinkle";
import { BuilderConfig as TwinkleConfig } from "../../slate/icons/foundation/Twinkle.builder";
import { Flex } from "../../slate/Layout/Flex";
import { BuilderConfig as FlexConfig } from "../../slate/Layout/Flex.builder";
import { Row } from "../../slate/Layout/Row/Row";
import { BuilderConfig as RowConfig } from "../../slate/Layout/Row/Row.builder";
import { Typography } from "../../slate/Typography/Typography";
import { BuilderConfig as TypographyConfig } from "../../slate/Typography/Typography.builder";
import { withTransformations } from "../registerBuilderComponents/withTransformations";

const BuilderAccordion = withTransformations(
  Accordion,
  AccordionConfig.transformations ?? {}
);
const BuilderButton = withTransformations(
  Button,
  ButtonConfig.transformations ?? {}
);
const BuilderArrowIcon = withTransformations(
  Arrow,
  ArrowConfig.transformations ?? {}
);
const BuilderCheckIcon = withTransformations(
  Check,
  CheckConfig.transformations ?? {}
);
const BuilderDollarIcon = withTransformations(
  Dollar,
  DollarConfig.transformations ?? {}
);
const BuilderEuroIcon = withTransformations(
  Euro,
  EuroConfig.transformations ?? {}
);
const BuilderFoundationIcon = withTransformations(
  FoundationIcon,
  FoundationIconConfig.transformations ?? {}
);
const BuilderGraphIcon = withTransformations(
  Graph,
  GraphConfig.transformations ?? {}
);
const BuilderPaymentPlanIcon = withTransformations(
  PaymentPlan,
  PaymentPlanConfig.transformations ?? {}
);
const BuilderPoundIcon = withTransformations(
  Pound,
  PoundConfig.transformations ?? {}
);
const BuilderShareHeartIcon = withTransformations(
  ShareHeart,
  ShareHeartConfig.transformations ?? {}
);
const BuilderTwinkleIcon = withTransformations(
  Twinkle,
  TwinkleConfig.transformations ?? {}
);
const BuilderLayout = withChildren(
  withTransformations(Flex, FlexConfig.transformations ?? {})
);
const BuilderRow = withChildren(
  withTransformations(Row, RowConfig.transformations ?? {})
);
const BuilderTypography = withTransformations(
  Typography,
  TypographyConfig.transformations ?? {}
);

export const registerBuilderComponents = () => {
  Builder.registerComponent(BuilderAccordion, {
    name: "Accordion",
    hideFromInsertMenu: false,
    inputs: [
      {
        name: "title",
        type: "string",
        defaultValue: "You may be wondering",
        localized: true,
      },
      {
        name: "titleAlignment",
        type: "string",
        enum: ["center", "end", "justify", "left", "right", "start", "unset"],
      },
      {
        name: "contents",
        type: "list",
        subFields: [
          {
            name: "question",
            type: "string",
            localized: true,
          },
          {
            name: "answer",
            type: "richText",
            localized: true,
          },
        ],
      },
    ],
  });

  Builder.registerComponent(BuilderButton, {
    name: "Button",
    hideFromInsertMenu: false,
    inputs: [
      {
        name: "disabled",
        type: "boolean",
      },
      {
        name: "linkTo",
        type: "string",
      },
      {
        name: "destructive",
        type: "boolean",
      },
      {
        name: "variant",
        type: "string",
        enum: ["primary", "secondary", "tertiary"],
        defaultValue: "primary",
      },
      {
        name: "small",
        type: "boolean",
      },
      {
        name: "tertiaryColor",
        type: "color",
      },
      {
        name: "replace",
        type: "boolean",
      },
      {
        name: "eventKeyOnClick",
        type: "string",
      },
      {
        name: "textContent",
        type: "string",
        defaultValue: "Button Text",
        localized: true,
      },
    ],
  });

  Builder.registerComponent(BuilderArrowIcon, {
    name: "ArrowIcon",
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "height",
        type: "string",
        defaultValue: "14",
      },
      {
        name: "width",
        type: "string",
        defaultValue: "14",
      },
      {
        name: "direction",
        type: "string",
        enum: ["up", "down", "left", "right", "upAndRight"],
      },
    ],
  });

  Builder.registerComponent(BuilderCheckIcon, {
    name: "CheckIcon",
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "height",
        type: "string",
        defaultValue: "24",
      },
      {
        name: "width",
        type: "string",
        defaultValue: "24",
      },
    ],
  });

  Builder.registerComponent(BuilderDollarIcon, {
    name: "DollarIcon",
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "height",
        type: "string",
        defaultValue: "24",
      },
      {
        name: "width",
        type: "string",
        defaultValue: "24",
      },
    ],
  });

  Builder.registerComponent(BuilderEuroIcon, {
    name: "EuroIcon",
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "height",
        type: "string",
        defaultValue: "24",
      },
      {
        name: "width",
        type: "string",
        defaultValue: "24",
      },
    ],
  });

  Builder.registerComponent(BuilderFoundationIcon, {
    name: "FoundationIcon",
    hideFromInsertMenu: false,
    inputs: [
      {
        name: "iconName",
        type: "string",
        enum: [
          "Account",
          "Add",
          "AddFile",
          "AddUser",
          "AlarmClock",
          "Announcement",
          "AnnouncementMuted",
          "Apple",
          "Application",
          "ArchiveBox",
          "Arrow",
          "ArrowAllDirections",
          "BarGraph",
          "Block",
          "Book",
          "Bookmark",
          "BookmarkTag",
          "Bottle",
          "Bowl",
          "BrokenLink",
          "BrowserCheck",
          "BrowserCode",
          "BrowserRemove",
          "BulkSelect",
          "BusinessCard",
          "Button",
          "Calculation",
          "Calendar",
          "CartEmpty",
          "CartItems",
          "Caution",
          "CautionSolid",
          "ChatBubble",
          "Check",
          "CheckInCircle",
          "CheckOutline",
          "Cheese",
          "Chevron",
          "CircleFilled",
          "Clipboard",
          "Clock",
          "ClockSolid",
          "Close",
          "Clover",
          "Columns",
          "Commitment",
          "Computer",
          "CreditCard",
          "CurrencyConverter",
          "CustomerSupport",
          "Diamond",
          "Divider",
          "Dollar",
          "DoubleChevron",
          "Download",
          "Duplicate",
          "Earn",
          "Edit",
          "Ellipsis",
          "Email",
          "EstimatedDeliveryDate",
          "Euro",
          "Exclamation",
          "ExclamationSolid",
          "Exclusivity",
          "Expand",
          "ExpandedLayout",
          "EyeOpen",
          "EyeClosed",
          "Eye",
          "Facebook",
          "File",
          "FileMultiple",
          "Filter",
          "Finance",
          "Glass",
          "Global",
          "Globe",
          "Gmail",
          "Google",
          "Graph",
          "Group",
          "Hamburger",
          "HappyFace",
          "Heart",
          "Home",
          "HorizontalEllipsis",
          "ImageLandscape",
          "InStock",
          "Information",
          "Instagram",
          "InterfaceSearch",
          "Language",
          "Leaf",
          "Lightbulb",
          "Link",
          "LinkedIn",
          "Location",
          "FoundationLock",
          "LockSquare",
          "LockCircle",
          "LockRoundBottom",
          "LockFlatTop",
          "LockRoundedSquare",
          "Lock",
          "MagicWand",
          "Minimize",
          "MobilePhone",
          "Mug",
          "NewTab",
          "Notification",
          "NotificationBell",
          "NotificationBellChecked",
          "OutOfStock",
          "Outlook",
          "OutlookColored",
          "Paperclip",
          "PartyPopper",
          "PaymentPlan",
          "Percentage",
          "Phone",
          "Pin",
          "Pound",
          "DollarPriceTag",
          "PoundPriceTag",
          "EuroPriceTag",
          "PriceTag",
          "Printer",
          "QRCode",
          "Redo",
          "Relationships",
          "ResponsibleConsumption",
          "Returns",
          "RewindClock",
          "SadFace",
          "SaleTag",
          "Save",
          "Search",
          "Send",
          "Settings",
          "Share",
          "ShareHeart",
          "ShipmentDelivered",
          "Shipping",
          "ShipsFrom",
          "Shopify",
          "ShopifyColored",
          "ShoppingBag",
          "Shuffle",
          "SingleColumn",
          "SocialFacebook",
          "SocialInstagram",
          "SocialLinkedIn",
          "SocialTwitter",
          "SocialYouTube",
          "Sort",
          "Split",
          "Sprout",
          "Square",
          "SquareLayout",
          "Star",
          "StarFilled",
          "Storefront",
          "Subtract",
          "Synchronized",
          "SynchronizedWarning",
          "TextFormattingJustified",
          "TextFormattingStyle",
          "ThumbsDown",
          "ThumbsUp",
          "TrashCan",
          "Truck",
          "Twinkle",
          "Twitter",
          "Undo",
          "Upload",
          "Utensils",
          "VerticalEllipsis",
          "VerticalExpand",
          "Video",
          "Yahoo",
          "YahooColored",
          "YouTube",
          "ZoomIn",
          "ZoomOut",
        ],
        defaultValue: "Account",
      },
      {
        name: "fontSize",
        type: "number",
        defaultValue: 14,
      },
      {
        name: "color",
        type: "color",
      },
      {
        name: "direction",
        type: "string",
        enum: ["up", "down", "left", "right", "upAndRight"],
      },
    ],
  });

  Builder.registerComponent(BuilderGraphIcon, {
    name: "GraphIcon",
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "height",
        type: "string",
        defaultValue: "24",
      },
      {
        name: "width",
        type: "string",
        defaultValue: "24",
      },
    ],
  });

  Builder.registerComponent(BuilderPaymentPlanIcon, {
    name: "PaymentPlanIcon",
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "height",
        type: "string",
        defaultValue: "24",
      },
      {
        name: "width",
        type: "string",
        defaultValue: "24",
      },
    ],
  });

  Builder.registerComponent(BuilderPoundIcon, {
    name: "PoundIcon",
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "height",
        type: "string",
        defaultValue: "24",
      },
      {
        name: "width",
        type: "string",
        defaultValue: "24",
      },
    ],
  });

  Builder.registerComponent(BuilderShareHeartIcon, {
    name: "ShareHeartIcon",
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "height",
        type: "string",
        defaultValue: "24",
      },
      {
        name: "width",
        type: "string",
        defaultValue: "24",
      },
    ],
  });

  Builder.registerComponent(BuilderTwinkleIcon, {
    name: "TwinkleIcon",
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "height",
        type: "string",
        defaultValue: "24",
      },
      {
        name: "width",
        type: "string",
        defaultValue: "24",
      },
    ],
  });

  Builder.registerComponent(BuilderLayout, {
    name: "Layout",
    hideFromInsertMenu: false,
    inputs: [
      {
        name: "align",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
        ],
      },
      {
        name: "justify",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
        ],
      },
      {
        name: "direction",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
        ],
      },
      {
        name: "gap",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "number",
          },
          {
            name: "tabletAndAbove",
            type: "number",
          },
          {
            name: "desktopAndAbove",
            type: "number",
          },
          {
            name: "xLargeAndAbove",
            type: "number",
          },
          {
            name: "xxLargeDesktop",
            type: "number",
          },
        ],
      },
    ],
  });

  Builder.registerComponent(BuilderRow, {
    name: "Row",
    hideFromInsertMenu: false,
    inputs: [
      {
        name: "align",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
        ],
      },
      {
        name: "justify",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
            ],
          },
        ],
      },
      {
        name: "direction",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
        ],
      },
      {
        name: "gap",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "number",
          },
          {
            name: "tabletAndAbove",
            type: "number",
          },
          {
            name: "desktopAndAbove",
            type: "number",
          },
          {
            name: "xLargeAndAbove",
            type: "number",
          },
          {
            name: "xxLargeDesktop",
            type: "number",
          },
        ],
      },
    ],
  });

  Builder.registerComponent(BuilderTypography, {
    name: "Typography",
    hideFromInsertMenu: false,
    inputs: [
      {
        name: "as",
        type: "string",
        enum: ["h1", "h2", "h3", "h4", "h5", "p", "span", "label"],
      },
      {
        name: "variant",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: [
              "displayXLSerifRegular",
              "displayLSerifRegular",
              "displayMSerifRegular",
              "displaySSerifRegular",
              "displaySSansSemiBold",
              "displaySSansRegular",
              "pageHeaderSerifRegular",
              "sectionHeaderSansMedium",
              "subheadingSansMedium",
              "subheadingSansRegular",
              "paragraphSansMedium",
              "paragraphSansRegular",
              "labelSansRegular",
              "labelSansMedium",
            ],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: [
              "displayXLSerifRegular",
              "displayLSerifRegular",
              "displayMSerifRegular",
              "displaySSerifRegular",
              "displaySSansSemiBold",
              "displaySSansRegular",
              "pageHeaderSerifRegular",
              "sectionHeaderSansMedium",
              "subheadingSansMedium",
              "subheadingSansRegular",
              "paragraphSansMedium",
              "paragraphSansRegular",
              "labelSansRegular",
              "labelSansMedium",
            ],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: [
              "displayXLSerifRegular",
              "displayLSerifRegular",
              "displayMSerifRegular",
              "displaySSerifRegular",
              "displaySSansSemiBold",
              "displaySSansRegular",
              "pageHeaderSerifRegular",
              "sectionHeaderSansMedium",
              "subheadingSansMedium",
              "subheadingSansRegular",
              "paragraphSansMedium",
              "paragraphSansRegular",
              "labelSansRegular",
              "labelSansMedium",
            ],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: [
              "displayXLSerifRegular",
              "displayLSerifRegular",
              "displayMSerifRegular",
              "displaySSerifRegular",
              "displaySSansSemiBold",
              "displaySSansRegular",
              "pageHeaderSerifRegular",
              "sectionHeaderSansMedium",
              "subheadingSansMedium",
              "subheadingSansRegular",
              "paragraphSansMedium",
              "paragraphSansRegular",
              "labelSansRegular",
              "labelSansMedium",
            ],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: [
              "displayXLSerifRegular",
              "displayLSerifRegular",
              "displayMSerifRegular",
              "displaySSerifRegular",
              "displaySSansSemiBold",
              "displaySSansRegular",
              "pageHeaderSerifRegular",
              "sectionHeaderSansMedium",
              "subheadingSansMedium",
              "subheadingSansRegular",
              "paragraphSansMedium",
              "paragraphSansRegular",
              "labelSansRegular",
              "labelSansMedium",
            ],
          },
        ],
      },
      {
        name: "color",
        type: "color",
      },
      {
        name: "align",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: [
              "center",
              "end",
              "justify",
              "left",
              "right",
              "start",
              "unset",
            ],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: [
              "center",
              "end",
              "justify",
              "left",
              "right",
              "start",
              "unset",
            ],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: [
              "center",
              "end",
              "justify",
              "left",
              "right",
              "start",
              "unset",
            ],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: [
              "center",
              "end",
              "justify",
              "left",
              "right",
              "start",
              "unset",
            ],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: [
              "center",
              "end",
              "justify",
              "left",
              "right",
              "start",
              "unset",
            ],
          },
        ],
      },
      {
        name: "truncate",
        type: "boolean",
      },
      {
        name: "maxLines",
        type: "number",
      },
      {
        name: "strikethrough",
        type: "boolean",
      },
      {
        name: "textContent",
        type: "string",
        defaultValue: "Enter some text...",
        localized: true,
      },
    ],
  });
};
